module.exports = __webpack_public_path__ + "static/media/pay-by-bank-bank-selected.cd6045ae.svg";